import Link from "@web-ui/adapters/link";

type LogoProps = {
    className?: string;
    /** The brand mark (the template ships a PNG; each app supplies its own mark). */
    children?: React.ReactNode;
    href?: string;
};

const Logo = ({ className, children, href = "/" }: LogoProps) => {
    return (
        <Link className={`block w-12 h-12 ${className || ""}`} href={href}>
            {children}
        </Link>
    );
};

export default Logo;
